module.exports = __webpack_public_path__ + "img/dz.782d42b3.webp";